define.alias("shared/utils/formatters/pin-from-dynamo", "media/utils/formatters/pin-from-dynamo");